import AppRoutes from 'redesign/routes/AppRoutes';

function App() {
    return <AppRoutes />;
}

export default App;
